import React, { useState, useEffect } from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableRow, Paper, 
    TableHead, Button, TablePagination, TextField, Dialog, 
    DialogActions, DialogContent, DialogContentText, DialogTitle 
} from '@mui/material';
import AddEtapaOportunidad from './AddEtapaOportunidad';
import { useAccesos } from '../contexts/AccesosContext';

function GestionEtapaOportunidad() {
const { tienePermiso } = useAccesos();

return (
<>
    <div className="x_title">
            {/* Aquí podrías agregar un título si lo necesitas */}
        </div>

        <div className="x_content">
            <br />

            <AddEtapaOportunidad />

            <div className="ln_solid" />

            <h2>Etapas de Oportunidad existentes</h2>

            <div className="row">
                <div className="col-md-6 col-sm-4 offset-md-3">
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Buscar Fuente de Origen"
                        placeholder="Buscar..."
                        style={{ marginBottom: '20px' }}
                    />

                    <div className="table-responsive">
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Descripción</TableCell>
                                        <TableCell>Porcentaje</TableCell>
                                        <TableCell align="right">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Prospecto / Nuevo</TableCell>
                                        <TableCell>20%</TableCell>
                                        <TableCell align="right">
                                            <Button color="primary" disabled={!tienePermiso('Editar Etapa Oportunidad')}>Editar</Button>
                                            <Button color="secondary" style={{ marginLeft: 10 }} disabled={!tienePermiso('Eliminar Etapa Oportunidad')}>
                                                Eliminar
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Calificación</TableCell>
                                        <TableCell>40%</TableCell>
                                        <TableCell align="right">
                                            <Button color="primary" disabled={!tienePermiso('Editar Etapa Oportunidad')}>Editar</Button>
                                            <Button color="secondary" style={{ marginLeft: 10 }} disabled={!tienePermiso('Eliminar Etapa Oportunidad')}>
                                                Eliminar
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                    {/* Más filas de ejemplo si las necesitas */}
                                </TableBody>
                            </Table>

                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={20} // Número de filas de ejemplo
                                rowsPerPage={5}
                                page={0}
                                onPageChange={() => {}}
                                onRowsPerPageChange={() => {}}
                            />
                        </TableContainer>

                        <Dialog open={false}>
                            <DialogTitle>Eliminar Etapa de Oportunidad</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    ¿Estás seguro de que quieres eliminar esta etapa de oportunidad?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button color="primary">Cancelar</Button>
                                <Button color="primary" autoFocus>Eliminar</Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    </>

     
    );
}

export default GestionEtapaOportunidad;